/**
 * Created by intellicar-kazi on 20/12/21.
 */
import React, {Component} from 'react';
import './TVSReportWidget.css';
import _ from 'lodash';
import InTable from '../InTable/InTable';
import humanizeDuration from "humanize-duration";
import moment from 'moment'; 
import StackBar from './StackBar';
import BarChart from './BarChart';
import D3pie from './D3PieChart';
const green = { 300: '#5ce3b5', 600: '#40dfa8', 900: '#37b9a2' };
const red = { 300: '#eb5971', 600: '#e9445f', 900: '#e62f4d' };
const yellow = { 300: '#fdcc55', 600: '#e9445f', 900: '#e62f4d' };
const blue = { 300: '#6cc0ed', 600: '#e9445f', 900: '#e62f4d' };
const colors = [blue[300], green[300], yellow[300], red[300],red[900]];
export default class TVSReportWidget extends Component {
    state = {
        index: 0,
        aggregate: false, 
        showTable: false,
        dataPerday: false,
        toggle:false,
        activeTab:0
    }
    onHover=(data)=>{
 this.setState({Vehicles:data})
    }
    onStackBarHover=(data)=>{
      this.setState({opVehicles:data})
    }
     speedRenderView = (data, radius,unit) => {
      return (
        <div style={{display:'flex',height:'78%', width:'100%'}}>
          <div className="ChartArea">
            <D3pie
              data={data}
              color={colors}
              onMouseMove={(legendKey) => {
                this.setState({activeLegend:legendKey})}}
              onMouseLeave={() => this.setState({activeLegend:''})}
              radius={radius}
              chart="speed"
            />
          </div>
          <div className="LegendArea">
            {data.map((legend, key) => {
              return (
                <div
                  key={key}
                  className={'Legend ' + (this.state.activeLegend === legend.label ? 'legendAnimate' : '')}
                  style={{ background: this.state.activeLegend === legend.label ? colors[key] : '#f4f4f4' }}
                  onMouseMove={() => this.setState({activeLegend:legend.label})}
                  onMouseLeave={() => this.setState({activeLegend:''})}
                  >
                  <div className="LegendTitle">
                    <i
                      className="fas fa-circle"
                      style={{ color: this.state.activeLegend === legend.label ? 'white' : colors[key] }}
                    ></i>
                    <span style={{ color: this.state.activeLegend === legend.label ? 'white' : '#252525' }}>
                      {legend.label+' '+unit}
                    </span>
                  </div>
                  <div
                    className="LegendValue"
                    style={{ color: this.state.activeLegend === legend.label ? 'white' : '#252525' }}
                  >
                    {legend.value.toFixed(0)+' %'}
                  </div>
                </div>
              );
            })}
          </div>
          </div>
        
      ) 
    };

    distanceRenderView = (data, radius,unit) => {
      return (
        <div style={{display:'flex',height:'78%', width:'100%'}}>
          <div className="ChartArea">
            <D3pie
              data={data}
              color={colors}
              onMouseMove={(legendKey) => this.setState({activeLegend2:legendKey})}
              onMouseLeave={() => this.setState({activeLegend2:''})}
              radius={radius}
              chart="distance"
            />
          </div>
          <div className="LegendArea">
            {data.map((legend, key) => {
              return (
                <div
                  key={key}
                  className={'Legend ' + (this.state.activeLegend2 === legend.label ? 'legendAnimate' : '')}
                  style={{ background: this.state.activeLegend2 === legend.label ? colors[key] : '#f4f4f4' }}
                  onMouseMove={() => this.setState({activeLegend2:legend.label})}
                  onMouseLeave={() => this.setState({activeLegend2:''})}
                >
                  <div className="LegendTitle">
                    <i
                      className="fas fa-circle"
                      style={{ color: this.state.activeLegend2 === legend.label ? 'white' : colors[key] }}
                    ></i>
                    <span style={{ color: this.state.activeLegend2 === legend.label ? 'white' : '#252525' }}>
                      {legend.label+' '+unit}
                    </span>
                  </div>
                  <div
                    className="LegendValue"
                    style={{ color: this.state.activeLegend2 === legend.label ? 'white' : '#252525' }}
                  >
                    {legend.value.toFixed(0)+' %'}
                  </div>
                </div>
              );
            })}
          </div>
          </div>
        
      ) 
    };

    generateStats =(stats={})=> {
        let statsData = window.rideReportData.statsdata[0]

        let unitFunc = (val) => {
            let v = parseInt(val, 10);
            return val % 1 === 0 ? 'HRS' : <div className="trwctcbcc-spx">{v > 1 ? <span>HRS</span> : null}<span>MIN</span></div>;
        }
        let valueFunc = (val) => {
            let min = parseInt(60 * (val % 1), 10);
            let v = parseInt(val, 10);
            return val % 1 === 0 ? val : <div className="trwctcbcc-spx">{v > 1 ? <span>{v}</span> : null}<span>{min}</span></div>;
        }
        let maxOpHours = parseFloat((((statsData.maxoperatingtime.operatingtime || {}) || 0) / (1000*60*60)).toFixed(1), 10);
        let maxTripDuration = parseFloat((((statsData.maxtripruntime.runningtime || {}) || 0) / (1000*60*60)).toFixed(1), 10);
        let maxStoppageDuration = parseFloat((((statsData.maxstoppagetime.stoppagetime || {}) || 0) / (1000*60*60)).toFixed(1), 10);
        let maxTripDurationPD = parseFloat((((statsData.maxdayruntime.runningtime || {}) || 0) / (1000*60*60)).toFixed(1), 10);
        return [
            {
                name: 'MAX NUMBER OF TRIPS ',
                unit: '',
                value: statsData.maxtrips.trips,
                vehicleno: statsData.maxtrips.vehicleno,
                time: statsData.maxtrips.time || 0,
                dateFormat: 'D MMM YYYY',
                ringColor: '#f1c40f',
            },
            {
                name: 'MAX DISTANCE',
                unit: 'KM',
                value: statsData.maxtripdistance.distance,
                vehicleno: statsData.maxtripdistance.vehicleno,
                time: statsData.maxtripdistance.time || 0,
                dateFormat: 'D MMM YYYY | hh:mm a',
                 value2: statsData.maxdaydistance.distance,
                 vehicleno2: statsData.maxdaydistance.vehicleno,
                 time2: statsData.maxdaydistance.time || 0,
                 dateFormat2: 'D MMM YYYY',
                ringColor: '#e74c3c',
                dataPerDay: false
                
            },
            {
                name: 'MAX SPEED',
                unit: 'KMPH',
                value: statsData.maxspeed.speed,
                vehicleno: statsData.maxspeed.vehicleno|| '',
                time: statsData.maxspeed.time || 0, 
                dateFormat: 'D MMM YYYY | hh:mm a',
                ringColor: '#e67e22',
            },
            {
                name: 'MAX OPERATING HOURS',
                unit: unitFunc(maxOpHours),
                value: valueFunc(maxOpHours),
                vehicleno: statsData.maxoperatingtime.vehicleno || '',
                time: statsData.maxoperatingtime.time || 0,
                dateFormat: 'D MMM YYYY',
                ringColor: '#3498db',
            },
            {
                name: 'MAX RUNNING DURATION',
                unit: unitFunc(maxTripDuration),
                value: valueFunc(maxTripDuration),
                vehicleno:  statsData.maxtripruntime.vehicleno|| '',
                time: statsData.maxtripruntime.time || 0,
                dateFormat: 'D MMM YYYY | hh:mm a',
                value2: valueFunc(maxTripDurationPD),
                vehicleno2: statsData.maxdayruntime.vehicleno|| '',
                time2: statsData.maxdayruntime.time|| 0,
                dateFormat2: 'D MMM YYYY',
                ringColor: '#9b59b6',
                dataPerDay:false
            },
            {
                name: 'MAX STOPPAGE DURATION',
                unit: unitFunc(maxStoppageDuration),
                value: valueFunc(maxStoppageDuration),
                vehicleno: statsData.maxstoppagetime.vehicleno || '',
                time: statsData.maxstoppagetime.time || 0,
                dateFormat: 'D MMM YYYY | hh:mm a',
                dateFormat2: 'D MMM YYYY',
                ringColor: '#34495e',
            },
        ]
    }
    getStats =()=> {
     return this.state.stats || []
    }

    toggleTripAndDay =item=> {
        item.dataPerDay = !item.dataPerDay;
        this.setState({toggle: true})
        this.forceUpdate();
    }

    renderCircleBox =(item, index)=> {
        return (
            <div className='trwct-circle-box' key={index}>
                <div className='trwctcb-container'>      
                    <div className='trwctcbc-circle' style={this.getCircleDimension(item)}>
                        { item.time2 ? (
                            <div className='trwctcbc-button'>
                                <span onClick={()=>this.toggleTripAndDay(item)}>{item.dataPerDay ? 'FOR DAY' : 'FOR TRIP'}</span>
                            </div>
                        ):''}
                        <div className='trwctcbc-date'><span>{this.getDateStr(item.dataPerDay ? item.time2 : item.time, item.dataPerDay ? item.dateFormat2 : item.dateFormat)}</span></div>
                        <div className='trwctcbc-name'>{item.name}</div>          
                        <div className='trwctcbc-driver'>{item.dataPerDay ? item.vehicleno2 :  item.vehicleno}</div>                
                        <div className='trwctcbcc-value'>{item.dataPerDay ? item.value2 :  item.value}</div>                
                        <div className='trwctcbcc-key'>{typeof item.unit === 'function' ? item.unit() : item.unit}</div>                
                    </div>                
                </div>
            </div>
        )
    }

    getCircleDimension =(item)=> {
        let width = parseInt(((window.innerHeight - 150) / 2) * 0.5, 10)
        return {
            width: width,
            height: width,
            marginLeft: width * -0.5,
            marginTop: width * -0.5,
            borderColor: item.ringColor || '#555',
        }
    }

    getDateStr =(time, dateFormat)=> time ? moment(time).format(dateFormat) : 'NO DATA';

    setTab =index=> {
        window.renderRideTable = true
        if(index == 2){
          let stats = {}
          if(window.rideReportData){
          stats = this.generateStats();
           this.setState({stats: stats});
          }
        }
        // _.set(window.rideReportTable, 'index', index);
        this.setState({index});
    }

    toggleAggregate = () => {
      window.renderRideTable = true
        _.set(window.rideReportTable, 'aggregate', !this.state.aggregate);
        this.setState(state => ({aggregate: !state.aggregate}));
    }
    componentDidUpdate(){
        if(window.rideReportTable && this.state.index === 0) {
            if(this.state.showTable == false){
                this.setState({showTable: true})
            }
            if(window.renderRideTable == true && !this.state.aggregate){
            this.refs.table.setData(window.rideReportTable);
            }
            if(window.renderRideTable == true && this.state.aggregate){
              this.refs.table.setData(window.aggregate);
              }
        }
         window.renderRideTable = false
    }
    render(){
        let tableData = {
            head: [
                {key:'vehicleno', name:'Vehicle No'},
            ].concat([
                {key:'date', name:'Date'},
            ]).concat([
                {key:'numtrips', name:'Trips/Day'},
                {key:'totaldistance', name:'Distance (km)'},
                {key:'opeartingtime', name:'Operating Duration'},
                {key:'runningtime', name:'Running Duration'},
                {key:'stoppagetime', name:'Stoppage Duration'},
                {key:'avgdistance', name:'Avg Distance/Trip (km)'},
                {key:'avgrunningtime', name:'Avg Duration/Trip'},
                {key:'avgstoppagetime', name:'Avg Stoppage Time Between Trips'},
                {key:'maxdistance', name:'Longest Trip (km)'},
            ]),
            _position: {
                width: 1000,
            }
        }

        let aggregate = {
          head: [
              {key:'vehicleno', name:'Vehicle No'},
          ]
          .concat([
              {key:'date', name:'Date'},
          ])
          .concat([
              {key:'allnumtrip', name:'Trips'},
              {key:'alltotaldistance', name:'Distance (km)'},
              {key:'allopeartingtime', name:'Operating Duration'},
              {key:'allrunningtime', name:'Running Duration'},
              {key:'allstoppagetime', name:'Stoppage Duration'},
              {key:'allavgdistance', name:'Avg Distance/Trip (km)'},
              {key:'allavgrunningtime', name:'Avg Duration/Trip'},
              {key:'allavgstoppagetime', name:'Avg Stoppage Time Between Trips'},
              {key:'allmaxdistance', name:'Longest Trip (km)'},
          ]),
          _position: {
              width: 1000,
          }
      }

        let renderTogglBtn = () => {
          let {aggregate} = this.state;
          return this.state.index === 0 ? <button onClick={this.toggleAggregate} className={aggregate ? 'actv' : ''}>
              <i className={'fa fa-toggle-' + (aggregate ? 'on' : 'off')}></i> Aggregate
          </button> : null
      }
        return (
            <div className='TVSReportWidget'>
                <div className='trw-tabs'>
                    <div className={('trwt-tab ' + (this.state.index === 0 ? 'active' : ''))} onClick={()=>this.setTab(0)}>TABLE</div>
                    <div className={('trwt-tab ' + (this.state.index === 1 ? 'active' : ''))} onClick={()=>this.setTab(1)}>TRENDS</div>
                    <div className={('trwt-tab ' + (this.state.index === 2 ? 'active' : ''))} onClick={()=>this.setTab(2)}>STATS</div>
                    <div className="trwt-btns">
                        {renderTogglBtn()}
                    </div>
                </div>
                <div className='trw-container'>

               {window.rideReportData == undefined &&<div className='trwc-tab'>
                            <div className="no-data">No Data</div>
                        </div>}
                    
                    {this.state.index === 0 && !this.state.aggregate  &&(
                        <div className='trwc-tab'>
                            <InTable ref="table" data={tableData} />
                        </div>
                    )}

                      {this.state.index === 0 && this.state.aggregate  &&(
                        <div className='trwc-tab'>
                            <InTable ref="table" data={aggregate} />
                        </div>
                    )}

                    {this.state.index === 2 && window.rideReportData != undefined &&(
                        <div className='trwc-tab'>
                            {this.getStats().map(this.renderCircleBox)} 
                        </div>
                    )}
                     {this.state.index === 1 &&   window.rideReportData != undefined &&(
                        <div className='trwc-tab'>
                            <div className="graph-upper">
                                <div className="upper-left" id= "upper-left">
                                 <div style={{display:"flex", justifyContent:'space-between'}}>
                                {<div className="graph-heading">Trips | Vehicles :{this.state.Vehicles? ' '+this.state.Vehicles: " -"}</div>}

                                <div className="WidgetTab">
                                      <ul>
                                        <li onClick={() => this.setState({activeTab:0})} className={this.state.activeTab === 0 ? 'active' : ''}>
                                          Avg
                                        </li>
                                        <li onClick={() => this.setState({activeTab:1})} className={this.state.activeTab === 1 ? 'active' : ''}>
                                          Total
                                        </li>
                                      </ul>
                                    </div>
                                    </div>
                                {this.state.activeTab==0 ? <BarChart actionOnClick={this.onHover} chartData={window.avgtripdata} xDataType="date" label="Avg No of Trips" />: <BarChart actionOnClick={this.onHover} chartData={window.totaltripdata} xDataType="date" label="No of Trips"/>}
                                </div>
                                <div className="upper-right" id='upper-right'>
                                <div className="graph-heading">Speed</div>
                                {this.speedRenderView(window.speedData, 0.6,'km/h')}
                                
                                </div>
                            </div>

                            <div className="middle"></div>

                            <div className="graph-lower">
                                {window.rideReportData && <div className="lower-left" id="lower-left">
                                  <div style={{display:"flex", justifyContent:'space-between'}}>
                                {<div className="graph-heading">Operating Hours | Vehicles :{this.state.opVehicles? ' '+this.state.opVehicles: " -"}</div>}

                                <div style={{display:'flex', marginTop:'25px', marginRight:'44px'}}>

                                <div style={{width:'15px', height:'15px', backgroundColor:'#273c75', marginRight:'3px'}}>
                                </div>
                                <div style={{marginRight:'10px', fontSize:'12px'}}>Running</div>

                                <div style={{width:'15px', height:'15px', backgroundColor:'#13abd4', marginRight:'3px'}}>
                                </div>
                                <div style={{marginRight:'10px', fontSize:'12px'}}>Stoppage</div>
                                </div>
                                </div>

                                <StackBar chartData={window.opTime} actionOnClick={this.onStackBarHover} label="Avg Duration(hr)"/>
                                </div>}

                                {window.rideReportData && <div className="lower-right" id="lower-right">
                                    <div className="graph-heading">Distance</div>
                                {this.distanceRenderView(window.distanceData,0,'km')}
                                </div>}
                            </div>
                        </div>
                    )}
                </div>              
            </div>
        )
    }
}
    